import { Typography } from '@navi/web-ui/lib/primitives';

export const ToastMessage = () => {
  return (
    <div>
      <Typography variant="p3" color="var(--navi-color-gray-c2)">
        Agents Availability History downloaded
        <br />
        for past 60 days
      </Typography>
    </div>
  );
};
